// extracted by mini-css-extract-plugin
export var colourBase = "bsRIdjKGOGXCqviFZe13";
export var colourDisabled = "_mm_oMVD7hVtynPMETsx";
export var colourInverted = "xuinB6N7mWXuKLNI7tfQ";
export var colourNegative = "liyngKFdp8e0JKWz3Uyb";
export var colourPositive = "QMiiP_4kF2B7CbIke3P6";
export var colourSubdued = "DPRBkmbGeoFQEpmKawFi";
export var colourSubtle = "kgQxE7EmsPHrLiWcuZe6";
export var colourUrgencyHigh = "PIyAVcgqJFpjXRDRq8rV";
export var colourUrgencyMedium = "qzglf7pb9nci1jGOKBPv";
export var colourWarning = "Ub_DRnpH4UHsd6nQTI09";
export var colourWhite = "Nh9yR46xjvRCneeuy463";